const Pencil = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M6.88277 18.8243L4.62691 19.6934C4.50972 19.739 4.4023 19.7097 4.30465 19.6055C4.2135 19.5079 4.19071 19.4004 4.23629 19.2833L5.16402 17.1055L15.8281 6.46099L17.5371 8.17974L6.88277 18.8243ZM18.3964 7.3399L16.6679 5.62115L17.6543 4.64459C17.9017 4.4037 18.1523 4.27349 18.4062 4.25396C18.6666 4.23443 18.9075 4.33534 19.1289 4.5567L19.4609 4.88873C19.6888 5.11659 19.7962 5.35748 19.7832 5.61138C19.7701 5.86529 19.6367 6.1192 19.3828 6.3731L18.3964 7.3399Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default Pencil;
